import { Box, Grid } from '@chakra-ui/react'

import styled, { keyframes } from 'styled-components'

const SkeletonAnimation = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

const Skeleton = styled(Box)`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${SkeletonAnimation} 1.5s infinite;
`

export function SkeletonLoading({ animate }) {
  return (
    <Grid
      templateColumns="repeat(12, 1fr)"
      gap={4}
      display="none"
      {...(animate && {
        display: 'grid',
      })}
    >
      {' '}
      <Skeleton
        gridColumn={{
          base: 'span 12',
          md: 'span 8',
        }}
        display="flex"
        alignItems="center"
        height="60px"
        border="1px solid #cfcfcf"
      ></Skeleton>
      <Skeleton
        gridColumn={{
          base: 'span 12',
          md: 'span 4',
        }}
        my="auto"
        height="60px"
        border="1px solid #cfcfcf"
      ></Skeleton>
      <Skeleton
        gridColumn={{
          base: 'span 12',
          md: 'span 8',
        }}
        height="158px"
        border="1px solid #cfcfcf"
      ></Skeleton>
      <Skeleton
        gridColumn={{
          base: 'span 12',
          md: 'span 4',
        }}
        border="1px solid #cfcfcf"
        height="158px"
      ></Skeleton>
      <Skeleton
        gridColumn={{
          base: 'span 12',
          md: 'span 4',
        }}
        border="1px solid #cfcfcf"
        height="374px"
      ></Skeleton>
      <Skeleton
        gridColumn={{
          base: 'span 12',
          md: 'span 4',
        }}
        border="1px solid #cfcfcf"
        height="374px"
      ></Skeleton>
      <Skeleton
        gridColumn={{
          base: 'span 12',
          md: 'span 4',
        }}
        border="1px solid #cfcfcf"
        height="374px"
      ></Skeleton>
      <Skeleton
        gridColumn="span 12"
        border="1px solid #cfcfcf"
        height="44px"
      ></Skeleton>
      <Skeleton
        gridColumn="span 12"
        border="1px solid #cfcfcf"
        height="146px"
      ></Skeleton>
      <Skeleton
        gridColumn="span 12"
        border="1px solid #cfcfcf"
        height="146px"
      ></Skeleton>
      <Skeleton
        gridColumn="span 12"
        border="1px solid #cfcfcf"
        height="146px"
      ></Skeleton>
      <Skeleton
        gridColumn="span 12"
        border="1px solid #cfcfcf"
        height="146px"
      ></Skeleton>
    </Grid>
  )
}
